import { BaseEntityWithSoftDelete } from '@models';

export class Site extends BaseEntityWithSoftDelete {
	name: string;
	address: string;
	dieselPrice: number;
	gasolinePrice: number;
	naturalGasPrice: number;
	electricityPrice: number;
	gplPrice: number;

	constructor(other?: Partial<Site>) {
		super();
		other && Object.assign(this, other);
	}
}
